export const transformChecklist = (data) => {
  const {
    name,
    ...rest
  } = data;

  return {
    ...rest,
    title: name,
  };
};
